(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-modern"]) return;
  try {
    
  const initCollectionModernControls = () => {
    const url = new URL(window.location.href);
    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    }

    const root = document.querySelector('results-list[section-id="{{ section.id }}"]');
    if (!root) return;

    const modeButtons = Array.from(root.querySelectorAll('[data-collection-view-mode]'));
    const normalizeMode = (value) => (value === 'design' ? 'design' : 'model');
    let activeMode = normalizeMode(url.searchParams.get('view'));

    const syncModeUi = () => {
      root.dataset.viewMode = activeMode;
      modeButtons.forEach((button) => {
        const isActive = button.dataset.collectionViewMode === activeMode;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    const applyModeToCards = () => {
      const targetIndex = activeMode === 'design' ? 1 : 0;
      root.querySelectorAll('product-card slideshow').forEach((slideshow) => {
        if (typeof slideshow.select !== 'function') return;
        const slideCount = Array.isArray(slideshow.slides) ? slideshow.slides.length : 0;
        const safeIndex = slideCount > targetIndex ? targetIndex : 0;
        slideshow.select(safeIndex, undefined, { animate: false });
      });
    };

    const persistMode = () => {
      const nextUrl = new URL(window.location.href);
      if (activeMode === 'design') {
        nextUrl.searchParams.set('view', 'design');
      } else {
        nextUrl.searchParams.delete('view');
      }
      window.history.replaceState({}, '', nextUrl.toString());
    };

    modeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeMode = normalizeMode(button.dataset.collectionViewMode);
        syncModeUi();
        persistMode();
        applyModeToCards();
      });
    });

    const observer = new MutationObserver(() => {
      applyModeToCards();
    });
    observer.observe(root, { childList: true, subtree: true });

    document.addEventListener('variant:update', () => {
      if (activeMode !== 'design') return;
      applyModeToCards();
    });

    syncModeUi();
    applyModeToCards();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionModernControls, { once: true });
  } else {
    initCollectionModernControls();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-style-lab"]) return;
  try {
    
  const initCollectionModernControls = () => {
    const url = new URL(window.location.href);
    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    }

    const root = document.querySelector('results-list[section-id="{{ section.id }}"]');
    if (!root) return;

    const modeButtons = Array.from(root.querySelectorAll('[data-collection-view-mode]'));
    const mountCollectionTabsInFilters = () => {
      const tabsSource = root.querySelector('[data-collection-tabs-source]');
      if (!tabsSource) return;

      const facetsVertical = root.querySelector('.facets--vertical');
      if (!facetsVertical) return;

      let mount = facetsVertical.querySelector('[data-collection-tabs-mount]');
      if (!mount) {
        mount = document.createElement('div');
        mount.className = 'collection-side-tabs';
        mount.setAttribute('data-collection-tabs-mount', '');
        facetsVertical.prepend(mount);
      }

      mount.innerHTML = tabsSource.innerHTML;
    };
    const normalizeMode = (value) => (value === 'design' ? 'design' : 'model');
    let activeMode = normalizeMode(url.searchParams.get('view'));

    const syncModeUi = () => {
      root.dataset.viewMode = activeMode;
      modeButtons.forEach((button) => {
        const isActive = button.dataset.collectionViewMode === activeMode;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    const getSlideCount = (slideshow) => {
      if (!slideshow) return 0;
      if (Array.isArray(slideshow.slides)) return slideshow.slides.length;
      if (slideshow.slides && typeof slideshow.slides.length === 'number') return slideshow.slides.length;
      if (slideshow.refs && Array.isArray(slideshow.refs.slides)) return slideshow.refs.slides.length;
      if (slideshow.refs && slideshow.refs.slides && typeof slideshow.refs.slides.length === 'number') {
        return slideshow.refs.slides.length;
      }
      return 0;
    };

    const applyModeToCards = () => {
      const targetIndex = activeMode === 'design' ? 1 : 0;
      root.querySelectorAll('product-card').forEach((card) => {
        const slideshow = card.refs?.slideshow || card.querySelector('slideshow-component, slideshow');
        if (typeof slideshow.select !== 'function') return;
        const slideCount = getSlideCount(slideshow);
        const safeIndex = slideCount > targetIndex ? targetIndex : 0;
        slideshow.select(safeIndex, undefined, { animate: false });
      });
    };

    const persistMode = () => {
      const nextUrl = new URL(window.location.href);
      if (activeMode === 'design') {
        nextUrl.searchParams.set('view', 'design');
      } else {
        nextUrl.searchParams.delete('view');
      }
      window.history.replaceState({}, '', nextUrl.toString());
    };

    modeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeMode = normalizeMode(button.dataset.collectionViewMode);
        syncModeUi();
        persistMode();
        applyModeToCards();
      });
    });

    const observer = new MutationObserver(() => {
      mountCollectionTabsInFilters();
      applyModeToCards();
    });
    observer.observe(root, { childList: true, subtree: true });

    document.addEventListener('variant:update', () => {
      if (activeMode !== 'design') return;
      applyModeToCards();
    });

    syncModeUi();
    mountCollectionTabsInFilters();
    applyModeToCards();
    requestAnimationFrame(applyModeToCards);
    setTimeout(applyModeToCards, 180);
    customElements.whenDefined('slideshow-component').then(applyModeToCards);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionModernControls, { once: true });
  } else {
    initCollectionModernControls();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
